module.exports = __webpack_public_path__ + "media/images/user/favicons/android-chrome-152x152-3753f6e10e18579728af3a441f255b1d.png";